import { z } from 'zod';

export const zenDeskSectionByIdSchema = z.object({
	id: z.number(),
	zenDeskId: z.number(),
	categoryId: z.number(),
	name: z.string(),
	description: z.string(),
});